import { render, staticRenderFns } from "./kirimanfrm.vue?vue&type=template&id=2d79aca8"
import script from "./kirimanfrm.vue?vue&type=script&lang=js"
export * from "./kirimanfrm.vue?vue&type=script&lang=js"
import style0 from "./kirimanfrm.vue?vue&type=style&index=0&id=2d79aca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports